import { Alert, Box, Skeleton } from '@ads-core/components';
import { PolygonMap } from '../PolygonMap';
import { RingsProps } from './hooks/useMapRings';

type DialogPolygonMapProps = RingsProps;

export const DialogPolygonMap = ({
  isLoading,
  isSuccess,
  isError,
  data,
}: DialogPolygonMapProps) => {
  const geometryRings = data?.geometryRingsByPostalCode;
  const mapHasData = isSuccess && geometryRings;
  const mapIsError = isError && !isLoading && !mapHasData;
  const rings = mapHasData ? Object.values(geometryRings).flat() : undefined;

  return (
    <Box width="100%" height="200px" borderRadius="brandLg" overflow="hidden">
      <Alert variant="warning">
        {mapIsError ? 'Er is iets mis gegaan tijdens het laden van de kaart.' : null}
      </Alert>
      {isLoading ? <Skeleton.Item width="100%" height="100%" /> : null}
      {mapHasData && <PolygonMap rings={rings} />}
    </Box>
  );
};
